import React from 'react'
import Page7 from '../components/Page7'
import Page3 from '../components/Page3'

import Header from '../components/Header'
import { Helmet } from 'react-helmet'

export default function Features() {
  return (
    <div>
            <Helmet>
        <title>Features | Andromeda</title>
        <meta name="description" content="Explore the key features of Andromeda-Sim, including Scheduler, Maintenance, and Qualification Test Guide (QTG) modules—designed to optimize simulator training, supervision, and maintenance processes for aviation training centers."/>
        <meta name="keywords" content="Andromeda-Sim, aviation simulator, Scheduler function, Maintenance module, QTG, Qualification Test Guide, simulator maintenance, aviation training, simulator software, training center management"/>
      </Helmet>
      <div className=''><Header/></div>
        <Page7/>
          <Page3/>
    </div>
  )
}
